import { z } from 'zod';

export const updatePaybackPlanResponseSchema = z.object({
  monthlyPayment: z.number(),
  numberOfInstallments: z.number(),
});
